import { render, staticRenderFns } from "./dayPeopleFlow.vue?vue&type=template&id=73db6a4b&scoped=true"
import script from "./dayPeopleFlow.vue?vue&type=script&lang=js"
export * from "./dayPeopleFlow.vue?vue&type=script&lang=js"
import style0 from "./dayPeopleFlow.vue?vue&type=style&index=0&id=73db6a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db6a4b",
  null
  
)

export default component.exports